// extracted by mini-css-extract-plugin
export var editor = "editor-module--editor--01abd";